import { fetchServiceConfigurationRefresh, createTokenRequest, getTokenDetails, getTokenValidity } from '../utils/authflow';
import { createContext, useContext, useEffect, useMemo, useState } from "react";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {

  const tokenDetails = getTokenDetails();
  const [accessToken, setAccessToken] = useState(tokenDetails?.accessToken?.accessToken);
  const claimsObj = tokenDetails?.idToken?.claims;
  let userIdFromToken = (claimsObj?.user) ? claimsObj?.user: claimsObj?.preferred_username;
  const [userDetails, setUserDetails] = useState({
    icon: getIconFromName(tokenDetails?.idToken?.claims?.name),
    userId: userIdFromToken,
    name: tokenDetails?.idToken?.claims?.name,
    email: tokenDetails?.idToken?.claims?.email,
    userGroup: tokenDetails?.idToken?.claims?.groups ?? [],
    isLoggedIn: tokenDetails !== null
  });

  useEffect(() => {
    const tokenDetails = getTokenDetails();
    if (accessToken && tokenDetails) {
      const tokenHandler = createTokenRequest();
      const diff = getTokenValidity();
      setTimeout(() => {
        fetchServiceConfigurationRefresh(tokenDetails.refreshToken, tokenHandler, setAccessToken);
      }, diff);
    }
  }, [accessToken]);

  const contextValue = useMemo(() => ({
    setAccessToken,
    accessToken,
    setUserDetails,
    userDetails
  }), [accessToken, userDetails]);

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export default AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};

export const getIconFromName = (name) => {
  if (name === undefined || name === null) {
    return "-"
  }

  const regex = /\(.*\)/i;
  name = name.replace(regex, '').trim();
  const nameArr = name.split(" ")
  if (nameArr.length === 1) {
    return nameArr[0][0]

  }
  return nameArr[0][0] + nameArr[nameArr.length - 1][0]
}

export const USERGROUP = {
  PROD_EXTERNAL: ["B2B_ofs_eiam_prod"],
  NONPROD_EXTERNAL: ["B2B_ofs_eiam_dev"],
  INTERNAL: ["myid_ofs_eiam_dev","myid_ofs_eiam_prod","myid_OFSE_prod_extensionAttribute6","myid_OFSE_dev_extensionAttribute6"]
}

export const isUserOfType = (userGroupList, userTypeList) => {
  if (!userGroupList) {
    return false;
  }
  const result = userGroupList.find(userGroup => {
      return userTypeList.includes(userGroup);
  });
  return result;
};

// As an External user I need an option to reset my password and option to access the service now portal.
export const ExternalProdUrl = "https://login.bakerhughes.com/signin/forgot-password"
export const ExternalNonProdUrl = "https://login-dev.bakerhughes.com/signin/forgot-password"
export const ExternalServiceNow = "https://beacon.bakerhughes.com/csm"

// As an Internal user I need an option to access the service now portal from the portal
export const InternalServiceNow = "https://bakerhughes.service-now.com/csm"
